export class ParameterAllRequestModel {
    ParameterGroupNameList: Array<string>;
}